export function resolveReturnsConfigKey(serviceKeys) {
  if (serviceKeys.has('wayfair_returns')) return 'wayfair_returns';
  if (serviceKeys.has('returns')) return 'returns';
  return null;
}
